import { render, staticRenderFns } from "./weitijao.vue?vue&type=template&id=1a91c374"
import script from "./weitijao.vue?vue&type=script&lang=js"
export * from "./weitijao.vue?vue&type=script&lang=js"
import style0 from "./weitijao.vue?vue&type=style&index=0&id=1a91c374&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports